import { Action } from 'redux';

import { PageItem } from '@src/types';

export const UI_SET_LANGUAGE = 'ui/SetLanguage';
export const UI_SET_THEME = 'ui/SetTheme';
export const UI_SHOW_SNACKBAR = 'ui/ShowSnackbar';
export const UI_HIDE_SNACKBAR = 'ui/HideSnackbar';
export const UI_SET_PRIME_HOME = 'ui/SetPrimeHome';
export const UI_SET_IMMIGRATION_HOME = 'ui/SetImmigrationHome';
export const UI_SET_TOUR_HOME = 'ui/SetTourHome';
export const UI_SET_VERSION = 'ui/SetVersion';
export const UI_SET_SEARCH = 'ui/SetSearch';
export const UI_SET_TOUR_SEARCH = 'ui/SetTourSearch';
export const UI_SET_TOUR_FILTER = 'ui/SetTourFilter';
export const UI_SET_HOME = 'ui/SetHome';

export type Version = number;
export type Theme = 'light' | 'dark';
export type Language = 'fa' | 'en';
export type Message = {
  content: string;
  action?: {
    label: string;
    accessibilityLabel?: string;
    onPress: () => void;
  };
  duration?: number;
};
export type TourFilter = {
  priceRange?: number[];
  activeTerms?: Record<number, boolean>;
};

export type SnackBar = {
  visible: boolean;
  message?: Message;
};

export interface SetLanguageAction extends Action<typeof UI_SET_LANGUAGE> {
  payload: Language;
}

export interface SetThemeAction extends Action<typeof UI_SET_THEME> {
  payload: Theme;
}

export interface SetPrimeHomeAction extends Action<typeof UI_SET_PRIME_HOME> {
  payload: PageItem[];
}
export interface SetImmigrationHomeAction
  extends Action<typeof UI_SET_IMMIGRATION_HOME> {
  payload: PageItem[];
}
export interface SetTourHomeAction extends Action<typeof UI_SET_TOUR_HOME> {
  payload: PageItem[];
}

export interface SetVersionAction extends Action<typeof UI_SET_VERSION> {
  payload?: Version;
}

export interface ShowSnackbarAction extends Action<typeof UI_SHOW_SNACKBAR> {
  payload: Message;
}

export interface HideSnackbarAction extends Action<typeof UI_HIDE_SNACKBAR> {}

export interface SetSearchAction extends Action<typeof UI_SET_SEARCH> {
  payload: string;
}

export interface SetTourSearchAction extends Action<typeof UI_SET_TOUR_SEARCH> {
  payload: string;
}

export interface SetTourFilterAction extends Action<typeof UI_SET_TOUR_FILTER> {
  payload: TourFilter;
}

export interface SetHomeAction extends Action<typeof UI_SET_HOME> {
  payload: PageItem[];
}

export type Actions =
  | SetLanguageAction
  | SetThemeAction
  | ShowSnackbarAction
  | HideSnackbarAction
  | SetVersionAction
  | SetPrimeHomeAction
  | SetImmigrationHomeAction
  | SetTourHomeAction
  | SetSearchAction
  | SetTourSearchAction
  | SetTourFilterAction
  | SetHomeAction;

export type State = {
  theme: Theme;
  language: Language;
  snackBar: SnackBar;
  primeHome: PageItem[];
  immigrationHome: PageItem[];
  tourHome: PageItem[];
  version?: number;
  search: string;
  tourSearch: string;
  tourFilter: TourFilter;
  home: PageItem[];
};
